import { Check } from 'lucide-react';
import { getCheckoutUrlWithUtms } from '@/lib/checkout';

const professionalBonuses = [
  {
    title: "BÔNUS #01-02: Regulação do Vínculo e Suporte Emocional Materno",
    description: "Aula 01 - Exterogestação: como orientar o vínculo mãe-bebê no pós-parto + Aula 02 - Técnicas de manejo emocional para mães em puerpério",
    icon: <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
          </svg>,
    originalValue: "R$ 297",
    currentValue: "R$ 0"
  },
  {
    title: "BÔNUS #03-04: Puerpério Clínico e Desenvolvimento do Recém-Nascido",
    description: "Aula 03 - Questões emocionais do puerpério: como identificar e encaminhar + Aula 04 - Estimulação sensorial: protocolo para consultório",
    icon: <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>,
    originalValue: "R$ 197",
    currentValue: "R$ 0"
  },
  {
    title: "BÔNUS #05-06: Osteopatia Aplicada e Práticas de Contenção",
    description: "Aula 05 - Osteopatia no suporte à amamentação: quando indicar e como orientar + Aula 06 - Uso de sling e contenção: orientação segura para famílias",
    icon: <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
          </svg>,
    originalValue: "R$ 147",
    currentValue: "R$ 0"
  },
  {
    title: "BÔNUS #07-08: Introdução Alimentar e Sono: Orientação Profissional",
    description: "Aula 07 - Introdução dos alimentos sólidos: protocolos e orientação clínica + Aula 08 - Sono infantil e amamentação: como orientar famílias no consultório",
    icon: <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
          </svg>,
    originalValue: "R$ 97",
    currentValue: "R$ 0"
  },
  {
    title: "BÔNUS #09-10: Manejo de Cólicas e Cuidados com o Recém-Nascido",
    description: "Aula 09 - Diagnóstico diferencial e manejo de cólicas: abordagem clínica + Aula 10 - Protocolo de cuidados com o recém-nascido para profissionais",
    icon: <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
          </svg>,
    originalValue: "R$ 197",
    currentValue: "R$ 0"
  }
];

const ProfessionalGuarantees = () => {
  const scrollToProduct = () => {
    const productSection = document.getElementById('cta');
    if (productSection) {
      productSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const totalBonusValue = professionalBonuses.reduce((sum, bonus) => {
    const value = parseInt(bonus.originalValue.replace(/\D/g, ''));
    return sum + value;
  }, 0);

  return (
    <section id="guarantees" className="py-20 relative overflow-hidden bg-[#ebf7f7]">
      <div className="absolute inset-0 z-0 opacity-30 pointer-events-none">
        <div className="absolute right-0 top-0 w-80 h-80 rounded-full bg-primary/20 blur-3xl"></div>
        <div className="absolute -left-20 bottom-0 w-60 h-60 rounded-full bg-primary/20 blur-3xl"></div>
      </div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 reveal">
            Suas Garantias Profissionais
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto reveal">
            Inscreva-se hoje no curso e receba benefícios exclusivos para potencializar seu desenvolvimento.
          </p>
        </div>
        
        <div className="max-w-6xl mx-auto">
          {/* Bônus Profissionais */}
          <div className="reveal mb-12">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">
              Bônus Exclusivos para Profissionais
            </h3>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {professionalBonuses.slice(0, 3).map((bonus, index) => (
                <div key={index} className="bg-white p-5 rounded-2xl shadow-soft border border-accent/10 card-hover" style={{
                  animationDelay: `${index * 0.1}s`
                }}>
                  <div className="flex gap-3">
                    <div className="flex-shrink-0 bg-accent/10 p-2 rounded-xl text-accent-ink h-fit">
                      {bonus.icon}
                    </div>
                    <div className="flex-1">
                      <div className="flex justify-between items-start mb-2">
                        <h4 className="text-base font-semibold text-gray-900">{bonus.title}</h4>
                        <span className="bg-accent/10 text-accent-ink text-xs font-medium px-2 py-1 rounded-full whitespace-nowrap ml-2 flex-shrink-0">
                          <span className="line-through">{bonus.originalValue}</span> {bonus.currentValue}
                        </span>
                      </div>
                      <p className="text-sm text-gray-600">{bonus.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
              {professionalBonuses.slice(3, 5).map((bonus, index) => (
                <div key={index + 3} className="bg-white p-5 rounded-2xl shadow-soft border border-accent/10 card-hover" style={{
                  animationDelay: `${(index + 3) * 0.1}s`
                }}>
                  <div className="flex gap-3">
                    <div className="flex-shrink-0 bg-accent/10 p-2 rounded-xl text-accent-ink h-fit">
                      {bonus.icon}
                    </div>
                    <div className="flex-1">
                      <div className="flex justify-between items-start mb-2">
                        <h4 className="text-base font-semibold text-gray-900">{bonus.title}</h4>
                        <span className="bg-accent/10 text-accent-ink text-xs font-medium px-2 py-1 rounded-full whitespace-nowrap ml-2 flex-shrink-0">
                          <span className="line-through">{bonus.originalValue}</span> {bonus.currentValue}
                        </span>
                      </div>
                      <p className="text-sm text-gray-600">{bonus.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          {/* Área de garantia e valor total */}
          <div className="flex flex-col lg:flex-row gap-8 items-stretch">
            {/* Garantia */}
            <div className="w-full lg:w-1/3 reveal">
              <div className="bg-white p-6 rounded-3xl shadow-soft border border-accent/20 h-full flex flex-col">
                <div className="flex items-center gap-4 mb-4">
                  <div className="flex-shrink-0 bg-accent/10 p-3 rounded-full text-accent-ink">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                    </svg>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900">Garantia de 7 Dias</h3>
                </div>
                <p className="text-gray-600 text-sm mb-4">
                  Se você não estiver completamente satisfeita com o curso dentro de 7 dias após a compra, devolvemos 100% do seu investimento, sem perguntas.
                </p>
                
                <ul className="space-y-2 mb-4">
                  <li className="flex items-center gap-2 text-sm">
                    <div className="flex-shrink-0 w-5 h-5 rounded-full bg-accent-ink flex items-center justify-center">
                      <Check className="h-3 w-3 text-white" strokeWidth={3} />
                    </div>
                    <span className="text-gray-700">Sem burocracia</span>
                  </li>
                  <li className="flex items-center gap-2 text-sm">
                    <div className="flex-shrink-0 w-5 h-5 rounded-full bg-accent-ink flex items-center justify-center">
                      <Check className="h-3 w-3 text-white" strokeWidth={3} />
                    </div>
                    <span className="text-gray-700">Processo simples de reembolso</span>
                  </li>
                  <li className="flex items-center gap-2 text-sm">
                    <div className="flex-shrink-0 w-5 h-5 rounded-full bg-accent-ink flex items-center justify-center">
                      <Check className="h-3 w-3 text-white" strokeWidth={3} />
                    </div>
                    <span className="text-gray-700">Investimento profissional protegido</span>
                  </li>
                </ul>
                
                <div className="mt-auto">
                  <div className="inline-block p-3 bg-accent/5 rounded-xl border border-accent/10 w-full text-center">
                    <p className="text-accent-ink font-medium text-sm">
                      Sem riscos para seu curso
                    </p>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Valor total e CTA */}
            <div className="w-full lg:w-2/3 reveal">
              <div className="bg-white p-6 rounded-3xl shadow-soft border border-accent/10 h-full flex flex-col">
                <div className="flex justify-between items-center mb-6 border-b border-gray-100 pb-4">
                  <span className="text-xl font-bold text-gray-900">Valor Total dos Bônus:</span>
                  <span className="text-2xl font-bold text-accent-ink">R$ {totalBonusValue}</span>
                </div>
                
                <div className="py-5 mb-6 border-b border-gray-100">
                  <div className="flex flex-col md:flex-row justify-between items-center gap-4">
                    <div className="text-left">
                      <p className="text-lg font-medium text-gray-800 mb-1">
                        Todos esses bônus profissionais estão incluídos no seu curso <span className="text-accent-ink font-bold">HOJE</span>
                      </p>
                      <p className="text-gray-600">
                        Aproveite essa oportunidade única e torne-se uma profissional reconhecida
                      </p>
                    </div>
                    <button 
                      className="btn-hover bg-accent-ink hover:bg-accent-ink-dark text-white font-medium px-8 py-3 rounded-full inline-flex items-center whitespace-nowrap flex-shrink-0" 
                      onClick={() => window.location.href = getCheckoutUrlWithUtms('https://pay.hotmart.com/T84177472Y?off=s3ddbg8f&checkoutMode=10')}
                    >
                      Garantir Curso
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                      </svg>
                    </button>
                  </div>
                </div>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-center">
                  <div className="p-2">
                    <p className="text-gray-600 text-sm mb-1">Acesso imediato a</p>
                    <p className="text-xl font-bold text-gray-900">12 Módulos Completos</p>
                  </div>
                  <div className="p-2">
                    <p className="text-gray-600 text-sm mb-1">Além de</p>
                    <p className="text-xl font-bold text-gray-900">10 Módulos de Bônus</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProfessionalGuarantees;